// #region MASTER DATA STATUS: ENUM

import { KeyInfoInterface } from "@/interfaces/KeyInfoInterface";
import { RestrictType } from "@/interfaces/RestrictType";

export enum MasterDataStatusEnum {
  DRAFT = 'draft',
  PENDING = 'pending',
  COMPLETED = 'completed',
};

// #endregion

// #region MASTER DATA STATUS: KEY INFO

export class MasterDataStatusKeyInfoClass implements RestrictType<MasterDataStatusEnum, KeyInfoInterface, MasterDataStatusKeyInfoClass> {
  get [MasterDataStatusEnum.DRAFT](): KeyInfoInterface {
    return {
      label: 'Draft',
      labelShort: 'Draft',
    }
  }

  get [MasterDataStatusEnum.PENDING](): KeyInfoInterface {
    return {
      label: 'Pending',
      labelShort: 'Pending',
    }
  }

  get [MasterDataStatusEnum.COMPLETED](): KeyInfoInterface {
    return {
      label: 'Completed',
      labelShort: 'Completed',
    }
  }
}

export const MasterDataStatusKeyInfo = new MasterDataStatusKeyInfoClass();

// #endregion
